import {
  css, type Interpolation,
} from '@emotion/react';
import type { OverlayScrollbarsComponentRef } from 'overlayscrollbars-react';
import {
  type ComponentProps,
  type CSSProperties, type FC, type MouseEvent, useCallback,
} from 'react';
import { OverlayScrollbarComponent } from '~/_shared/components/scrollbar/overlayScrollbar.component';

export enum ScrollbarType {
  Vertical = 'Vertical',
  Horizontal = 'Horizontal',
}

export type ScrollbarProps = Readonly<{
  className?: string;
  contentStyle?: Interpolation;
  isScrollbarHidden?: boolean;
  maxHeight?: number | string;
  type: ScrollbarType | ScrollbarType[];
  getScrollbarReference?: (ref: OverlayScrollbarsComponentRef) => void;
  onClick?: (e: MouseEvent) => void;
  onScrollTop?: () => void;
  onUpdate?: ComponentProps<typeof OverlayScrollbarComponent>['onUpdate'];
  children?: React.ReactNode;
  style?: CSSProperties;
}>;

const scrollableElementStyles = css({ maxHeight: '100%', minHeight: '100%' });

export const ScrollBarComponent: FC<ScrollbarProps> = ({
  children,
  className,
  contentStyle,
  getScrollbarReference,
  isScrollbarHidden,
  maxHeight,
  onClick,
  onUpdate,
  style,
  type,
}) => {
  const updateRef = useCallback((el: OverlayScrollbarsComponentRef) => {
    if (el && getScrollbarReference) {
      getScrollbarReference(el);
    }
  }, [getScrollbarReference]);

  return (
    <OverlayScrollbarComponent
      className={className}
      css={scrollableElementStyles}
      isScrollbarHidden={isScrollbarHidden}
      maxHeight={maxHeight}
      onClick={onClick}
      onUpdate={onUpdate}
      ref={updateRef}
      style={style}
      type={type}
    >
      <div css={contentStyle} data-element="scrollable-content">
        {children}
      </div>
    </OverlayScrollbarComponent>
  );
};
